import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { localize } from "src/l10n";
import { debounce } from "src/utils";
import { Label, Scrollable } from ".";
import { Style } from "../helpers";
import { UnstyledButton } from "./Buttons";

interface IProps {
    tableOfContentSearchElementRef: any;
    isSmallViewMode: boolean;
}

interface IState {
    isLoading: boolean;
    headers: any[];
    fixedMode: boolean;
    marginTop: number;
}

class TableOfContent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            headers: [],
            fixedMode: false,
            marginTop: 0
        };
    }

    getHeaders() {
        const wrapper = ReactDOM.findDOMNode(this.props.tableOfContentSearchElementRef.current);

        if (!wrapper) {
            return;
        }

        // @ts-ignore
        const headerElements = wrapper.querySelectorAll('h1, h2, h3, h4, h5, h6');

        const headers = [];

        for (const h of headerElements) {
            const text = h.innerText.replace(/(\r\n|\n|\r)/gm, '').trim();

            if (!text) {
                continue;
            }

            headers.push({
                text,
                el: h
            });
        }

        this.setState({
            isLoading: false,
            headers
        });
    }

    listenToScroll() {
        const winScroll = document.body.scrollTop ||
            document.documentElement.scrollTop;

        const shouldBeFixedMode = winScroll > 300;

        this.setState({
            fixedMode: shouldBeFixedMode,
            marginTop: Math.max(0, winScroll - 200)
        });
    }

    debouncedListenToScroll = debounce(this.listenToScroll.bind(this), 50);

    componentDidMount() {
        this.getHeaders();

        setInterval(() => {
            if (!this ||
                !this.state) {
                return;
            }

            this.getHeaders();
        }, 5000);

        window.addEventListener('scroll', this.debouncedListenToScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.debouncedListenToScroll);
    }

    render() {
        if (this.state.isLoading ||
            !this.state.headers ||
            this.state.headers.length === 0) {
            return null;
        }

        return (
            <div style={{
                position: "relative"
            }}>
                <div className="TableOfContent" style={{
                    width: "100%",
                    position: this.state.fixedMode ? "absolute" : "relative",
                    marginTop: this.state.fixedMode ? this.state.marginTop : 0,
                    transition: "margin-top 0.25s linear"
                }}>
                    <Label
                        size="body-2"
                        color="mid-grey"
                        className="header"
                        style={{
                            marginBottom: Style.getSpacingStr(2),
                            overflowWrap: "normal",
                            wordBreak: "normal",
                        }}
                    >
                        {
                            localize("Innehallsforteckning")
                        }
                    </Label>
                    <div
                        className="TableOfContent-items"
                        style={{
                            ...(!this.props.isSmallViewMode ? { height: 300, minWidth: 250 } : {}),
                        }}
                    >
                        <Scrollable>
                            <div>
                                {
                                    this.state.headers.map((header, index) => {
                                        return (
                                            <div key={index} >
                                                <UnstyledButton onClick={() => {
                                                    window.scrollTo({
                                                        top: header.el.getBoundingClientRect().top + window.scrollY,
                                                        left: 0,
                                                        behavior: 'smooth'
                                                    });
                                                }}>
                                                    <Label size="body-2" color="light-blue">
                                                        {
                                                            header.text
                                                        }
                                                    </Label>
                                                </UnstyledButton>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Scrollable>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: Spintr.AppState, props) => {
    return {
        ...props,
        isSmallViewMode: state.ui.isSmallViewMode,
    };
};

export default connect(mapStateToProps)(TableOfContent);
